import { TemplateResult, html } from 'lit';
import { OutlineElement } from '../outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import { icons } from './icons';
// import * as feather from '../../../../node_modules/feather-icons/dist/feather.min.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import outline from '../../../resolved-outline-config';

/**
 * Pull the icon list from the feather-icons package in order
 * to create the list of available icons.
 */
export const availableIcons = icons
  ? Object.keys(icons).map(key => {
      return key;
    })
  : [];
export type FeatherIcons = typeof availableIcons[number];
/**
 * The OutlineFeatherIcon component
 * @element outline-feather-icon
 */
@customElement('outline-feather-icon')
export class OutlineFeatherIcon extends OutlineElement {
  /**
   * String name of feather icon.
   *
   * @see https://feathericons.com/
   */
  @property({ type: String, attribute: 'icon' })
  icon: FeatherIcons = outline.feather.icon ? outline.feather.icon : 'activity';

  /**
   * The width and height of the icon on screens larger than mobile
   * @param size in pixels
   * @default 1em
   */
  @property({ type: String, attribute: 'size' })
  size = outline.feather.size ? outline.feather.size : '1em';

  /**
   * The actual color of the icon, provided by the SVG stroke.
   * @param color to use for icon
   * @default currentColor
   */
  @property({ type: String, attribute: 'color' })
  color = outline.feather.color ? outline.feather.color : 'currentColor';

  /**
   * The width of the stroke on the icon.
   * @param strokeWidth width of the icon's stroke
   * @default 2
   */
  @property({ type: Number, attribute: 'stroke-width' })
  strokeWidth = outline.feather.strokeWidth ? outline.feather.strokeWidth : 2;

  // Invoked when a component is added to the document's DOM.
  connectedCallback() {
    super.connectedCallback();
    window.feather.replace();
  }

  render(): TemplateResult {
    const iconSvg = window.feather.icons[`${this.icon}`]?.toSvg({
      'color': this.color,
      'width': this.size,
      'height': this.size,
      'stroke-width': this.strokeWidth,
    });
    return html`${unsafeHTML(iconSvg)}`;
  }
}
